<div id="trainers-container" class="container">
    <h1 jhitranslate="trainer-list.trainers">
        <i class="fa fa-users fa-pre" aria-hidden="true"></i>
        {{ 'trainer-list.trainers' | translate }}
    </h1>
    <div class="filters-parent">
        <div class="filters">
            <div
                style="float:right;"
                class="label label-default label-skill label-skill--refuse-highlight"
            >
                {{ 'trainer-list.refuse' | translate }}
            </div>
            <div
                style="float:right;"
                class="label label-default label-skill label-skill--followed-highlight"
            >
                {{ 'trainer-list.followed' | translate }}
            </div>
            <div
                style="float:right;"
                class="label label-default label-skill label-skill--wished-highlight"
            >
                {{ 'trainer-list.wished' | translate }}
            </div>
            <div
                style="float:right;"
                class="label label-default label-skill label-skill--given-highlight"
            >
                {{ 'trainer-list.given' | translate }}
            </div>
            <div
                style="float:right;"
                class="label label-default label-skill label-skill--can-highlight"
            >
                {{ 'trainer-list.can' | translate }}
            </div>
            <label class="control-label" for="search">{{ 'trainer-list.search' | translate}} </label>
            <input class="form-control input-filter" id="search" type="text" [(ngModel)]="search"
                   placeholder="{{ 'trainer-list.placeHolder' | translate}}" (ngModelChange)="searchByNameOrSkill()" #searchInput>

            <select class="form-control" class="language-filter" id="languageFilter" [(ngModel)]="selectedLanguage">
                <option value="all">{{'global.language.all' | translate}}</option>
                <option *ngFor="let language of availableLanguages"
                        [ngValue]="language"> {{'global.language.' + language | translate}}
                </option>
            </select>

            <select class="form-control" class="agency-filter" id="priceCurrency" [(ngModel)]="agencyFilter" (ngModelChange)="onAgencyFilterChange($event)">
                <option>Toutes les agences</option>
                <option *ngFor="let agency of agencies" [ngValue]="agency.name">
                    {{ agency.name | cleanAgencyName }}
                </option>
            </select>

            <div (click)="activeClicked()" class="active-filter">{{ 'trainer-list.active' | translate}}
                <span *ngIf="active"><i class="fa fa-check-circle" aria-hidden="true"></i></span>
                <span *ngIf="!active"><i class="fa fa-circle-thin" aria-hidden="true"></i></span>
            </div>
        </div>
    </div>
    <div class="trainers-result" *ngIf="loadingTrainers">
        <div class="trainer-list row">
            <div class="filterMetadata col-xs-12">
                <div class="flex">
                    <div class="counter">
                        Chargement...
                    </div>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="trainers-result" *ngIf="!loadingTrainers">
        <div class="trainer-list row" *ngIf="search === '' && agencyFilter !== 'Toutes les agences'">
            <div class="filterMetadata col-xs-12">
                <div class="flex">
                    <div class="counter">
                        {{filterMetadata.countName}} {{ filterMetadata.countName > 1 ? 'formateurs et formatrices' : 'formateur ou formatrice' }}
                        à {{agencyFilter}}
                    </div>
                    <div class="line"></div>
                </div>
            </div>
            <div
                *ngFor="let trainer of trainers | filterByNameOrLabel:'':active | filterByLanguage:selectedLanguage:filterMetadata:'name'"
                uiSref="trainer-detail"
                [uiParams]="{ id: trainer.id }"
                class="col-md-4 col-sm-6 col-xs-12"
            >
                <trainer-card [trainer]="trainer"></trainer-card>
            </div>
        </div>

        <div class="trainer-list row" *ngIf="search !== ''">
            <div class="filterMetadata col-xs-12">
                <div class="flex">
                    <div class="counter">
                        {{filterMetadata.countName}} {{ filterMetadata.countName > 1 ? 'résultats' : 'résultat' }}
                    </div>
                    <div class="line"></div>
                </div>
            </div>
            <div
                *ngFor="let trainer of trainers | filterByNameOrLabel:'':active | filterByLanguage:selectedLanguage:filterMetadata:'name'"
                uiSref="trainer-detail"
                [uiParams]="{ id: trainer.id }"
                class="col-md-4 col-sm-6 col-xs-12"
            >
                <trainer-card [trainer]="trainer"></trainer-card>
            </div>
        </div>
    </div>
    <button
        *jhiHasAnyAuthority="'ROLE_ADMIN'"
        class="btn btn-primary btn-round btn-lg"
        uiSref="trainer-create"
    >
        +
    </button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/trainer.component.html